<template>
  <div class="patientHistoryTable">
    <rp-table
      name="patient history"
      :results="getData"
      noPagination
      :headings="['date', 'description']">
    </rp-table>
  </div>
</template>

<script>
import Table from 'raypro_ui/src/components/ui/Table'

// API
import {getPatientHistory} from 'raypro_ui/src/api/users'

export default {
  components: {'rp-table': Table},

  data() {
    return {patientHistory: []}
  },
  props: {patientId: {required: true}},

  methods: {
    formatDate(d) {
      const date = new Date(d.toString())
      const formattedDate = date
        .toLocaleDateString('en-GB', {day: 'numeric', month: 'short', year: 'numeric'})
        .replace(/[_-]/g, ' ')
        .toUpperCase()

      return formattedDate
    },

    formatDescription(d) {
      const description = d
        .toString()
        .replace(/[_-]/g, ' ')

      return description
    },

    getData() {
      return getPatientHistory(this.patientId).then(({data}) => {
        const operations = data.patient_operations.map((row) => {
          return {
            date: this.formatDate(Object.values(row)),
            description: this.formatDescription(Object.keys(row))
          }
        })

        const questionnairesArray = []

        data.patient_questionnaires.map((row) => {
          return Object.entries(row).forEach((d) => {
            if(d[1]) {
              questionnairesArray.push({date: this.formatDate(d[1]), description: this.formatDescription(d[0])})
            }
          })
        })

        const date = [{date: this.formatDate(data.profile_created_at), description: 'Patient profile created'}]

        const d = date.concat(operations, questionnairesArray)
        const sortedByDate = d.sort((a, b) => {
          return new Date(a.date) - new Date(b.date)
        })

        return {data: sortedByDate}
      })
    }
  }
}
</script>

<style lang="sass">
@import 'raypro_ui/src/styles/base/_variables.sass'
@import 'raypro_ui/src/styles/helpers/_mixins.sass'

.patientHistoryTable
  .table
    box-shadow: $color-shadow
    border-radius: none
    -webkit-box-shadow: none !important
    box-shadow: none !important

    .table-header, .table-row
      border-bottom: 1px solid $color-grey-light
</style>



// WEBPACK FOOTER //
// src/components/pages/Patients/PatientHistory.vue